import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory, useParams } from "react-router-dom";

import {
  subirImagenesBatch,
  actualizarRegistro,
  getEmployeeNumber,
  getUserByEmail,
  loadAccountList,
  obternerRegistroxID,
} from "../utils/Actions";
import { isEmpty } from "lodash";
import Avatar from "@material-ui/core/Avatar";
import { Loading } from "../atoms";
import { generatePasswordRand, sendEmail, validaremail } from "../utils/Utils";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";

const inintialState = {
  titulo: "",
  descripcion: "",
  fecha: new Date(),
  photo: "",
  tiporeclamo: "1",
  status: false,
  respuesta: "",
};

const roles = [
  { code: 1, title: "Pregunta" },
  { code: 2, title: "Reclamos" },
];

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    alignSelf: "center",
  },
  avatar: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
}));

export default function EditClaims() {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [accountlist, setaccountlist] = useState([]);
  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);

  const classes = useStyles();
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];
  console.log(accountJSON);

  let history = useHistory();
  let { id } = useParams();
  const claimid = id.slice(4);
  console.log("USUARIO");
  console.log(claimid);

  useEffect(() => {
    (async () => {
      console.log("LOAD ACCOUNT LIST");
      setaccountlist((await loadAccountList()).data);

      const respuesta = await obternerRegistroxID("Claims", claimid);
      console.log("RESPUESTA");
      console.log(respuesta);
      setstate(respuesta.data);
    })();
  }, []);

  const defaultProps = {
    options: roles,
    getOptionLabel: (option) => option.title,
  };

  const defaultProps2 = {
    options: accountlist,
    getOptionLabel: (option) => option.name,
  };

  const fileSelectedHandler = async (event) => {
    setVisible(true);

    setstate({ ...state, photo: event.target.files });
    setVisible(false);
  };

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const _saveuser = async () => {
    //1. Subir imagen
    const {
      titulo,
      descripcion,
      fecha,
      photo,
      tiporeclamo,
      status,
      respuesta,
    } = state;
    let emaildelcliente = state.email;

    if (isEmpty(titulo)) {
      alert("Favor ingrese un título");
    } else if (isEmpty(descripcion)) {
      alert("Favor ingrese una descripción");
    } else {
      setVisible(true);
      //2. Generar claves

      let photoup = "";
      if (photo) {
        const resultado = await subirImagenesBatch(photo, "PhotoReclamos");
        photoup = resultado[0];
      }

      const account = localStorage.getItem("Account");
      const accountJSON = JSON.parse(account);

      const { id, accountAsigned, accountAsignedName, email, name, lastname } =
        accountJSON[0];

      const reclamoopregunta = {
        titulo,
        descripcion,
        fecha,
        tiporeclamo,
        status,
        updatedBy: id,
        updatedName: name,
        updatedLastName: lastname,
        updatedAt: new Date(),
        email,
        name,
        lastname,
        respuesta,
        status: rol !== 4 && !isEmpty(respuesta) ? true : false,
      };
      console.log("Estos son los datos");
      console.log(reclamoopregunta);
      const registro = await actualizarRegistro(
        "Claims",
        claimid,
        reclamoopregunta
      );
      console.log("RESPUESTA");
      console.log(registro);

      if (registro.statusresponse === true) {
        if (emaildelcliente) {
          await sendEmail(
            `Se ha actualizado su solicitud.   
            Su solicitud ha sido actualizada`,
            "ACTUALIZACIÓN DE RECLAMO O PREGUNTA SAYERET SECURITY",
            emaildelcliente
          );
        }

        await sendEmail(
          `Se ha actualizado su solicitud.   
          Su solicitud ha sido actualizada`,
          "ACTUALIZACIÓN DE RECLAMO O PREGUNTA SAYERET SECURITY",
          email
        );

        alert("Se ha actualizado el registro exitosamente");
        history.push("/claims");
      } else {
        setVisible(false);
        alert("Ha ocurrido un error - CODIGO" + registro.error);
      }
    }
    setVisible(false);
  };

  const getTipoReclamo = (rol) => {
    if (Number(rol) === 1) {
      return "Pregunta";
    } else if (Number(rol) === 2) {
      return "Reclamo";
    }
  };

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        {rol !== 4 ? " Editar Preguntas o Reclamos" : "Ver Pregunta o Reglamo"}
      </Typography>

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Título"
            variant="outlined"
            fullWidth
            name="titulo"
            onChange={onChange}
            value={state.titulo}
            disabled={rol === 4 ? true : false}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Descripción"
            variant="outlined"
            fullWidth
            name="descripcion"
            onChange={onChange}
            value={state.descripcion}
            multiline={true}
            rows={4}
          />
        </Grid>
        {/*
          <Grid item xs={6}>
            <TextField
              id="outlined-basic"
              label="Resolución"
              variant="outlined"
              fullWidth
              name="userweb"
              onChange={onChange}
              disabled
              value={`${state.name}.${state.lastname}`}
            />
          </Grid> */}
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Fecha"
            variant="outlined"
            fullWidth
            type="date"
            name="fecha"
            onChange={onChange}
            value={state.fecha}
          />
        </Grid>

        <Grid
          item
          xs={6}
          direction="column"
          justify="center"
          alignItems="center"
          container
          spacing={0}
          style={{ marginBottom: 20 }}
        >
          {!isEmpty(state.photo) ? (
            <img src={state.photo} style={{ width: 350 }} />
          ) : (
            <input
              type="file"
              onChange={fileSelectedHandler}
              accept="image/png, image/jpeg"
            />
          )}
        </Grid>

        <Grid item xs={4}>
          <Autocomplete
            {...defaultProps}
            id="open-on-focus"
            openOnFocus
            renderInput={(params) => (
              <TextField {...params} label="Tipo de Registro" margin="normal" />
            )}
            onChange={(event, newValue) => {
              console.log(newValue);
              setstate({ ...state, tiporeclamo: newValue.code });
            }}
            value={{
              code: state.tiporeclamo,
              title: getTipoReclamo(state.tiporeclamo),
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                onChange={(e) => {
                  setstate({ ...state, status: e.target.checked });
                }}
                value={Boolean(state.status)}
                disabled={rol === 4 ? true : false}
              />
            }
            label="Estatus de Atención"
            labelPlacement="start"
            checked={Boolean(state.status)}
          />
        </Grid>
        {
          <Grid item xs={4}>
            <TextField
              id="outlined-basic"
              label="Respuesta"
              variant="outlined"
              fullWidth
              type="text"
              name="respuesta"
              onChange={onChange}
              value={state.respuesta}
              multiline={true}
              rows={3}
            />
          </Grid>
        }

        {rol !== 4 && (
          <Grid
            item
            xs={12}
            direction="row"
            justify="center"
            alignItems="center"
            container
          >
            <Button
              size="large"
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={_saveuser}
            >
              ACTUALIZAR
            </Button>
          </Grid>
        )}
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />
    </FormControl>
  );
}
